import 'twin.macro';
import React from 'react';
import qs from 'qs';
import H2 from '@teetsh/app/src/components/Typography/Headings/H2';
import SimpleModal from '@teetsh/app/src/components/SimpleModal';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { format } from '@teetsh/app/src/utils/time/format';
import subscriptionUrl from '@teetsh/app/src/containers/UserSettings/Souscription/urls';
import { useBillingInfos } from 'queries/useBillingInfos';
import { frenchDatePatternWithSlashes } from 'utils/time/datePatterns';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useTranslation } from 'react-i18next';
import { useGetPlans } from 'queries/plan/useGetPlans';
import ScreenSpinner from 'components/Spinner/ScreenSpinner';

export function Recap() {
  const { data: billingInfos } = useBillingInfos();
  const { locale } = useUser();
  const { data: plans, isLoading } = useGetPlans(locale);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation(['userSettings', 'common']);
  const onClose = () => navigate(subscriptionUrl.subscription);
  const params = qs.parse(location.search.substr(1));
  const plan = (plans || []).find(p => p.id === params.previousPlan);

  if (isLoading) {
    return <ScreenSpinner />;
  }
  if (!plan) {
    return <Navigate to={subscriptionUrl.subscription} />;
  }
  return (
    <SimpleModal
      isOpen
      closeModalFct={() => onClose()}
      intent="primary"
      validateTitle={t('common:buttons.continue')}
      validateAction={() => onClose()}
    >
      <div tw="p-8">
        <H2 tw="mb-8">{t('userSettings:subscription.cancel.recap.title')}</H2>
        <div>
          <div tw="mb-3">
            {t('userSettings:subscription.cancel.recap.subscriptionCancelled', {
              label: plan.label,
            })}
          </div>
          {billingInfos?.expirationDate && (
            <div>
              {t('userSettings:subscription.cancel.recap.featureAccess', {
                date: format(
                  billingInfos.expirationDate as Date,
                  locale,
                  frenchDatePatternWithSlashes,
                ),
              })}
            </div>
          )}
        </div>
      </div>
    </SimpleModal>
  );
}
